import { Color, RadiusScale, withCitrusTheme } from '@gousto-internal/citrus-react';
import { gridCols, gridRows, gridTemplateAreas } from './layout';

/**
 * A button that contains _most_ of the RecipeCard's content
 *
 * As HTML buttons cannot be nested, the RecipeCard Container also uses a matching
 * grid layout to enable items to accurately overlay this button.
 */
export const ClickableArea = withCitrusTheme('button', (theme) => ({
  ...theme.radius(2 as RadiusScale),
  padding: '0',
  overflow: 'hidden',
  border: 'none',
  display: 'grid',
  gridTemplateRows: gridRows,
  gridTemplateColumns: gridCols,
  gridTemplateAreas: gridTemplateAreas,
  gridColumn: '1',
  gridRow: '1 / span 3',
  cursor: 'pointer',
  '&:focus': {
    outline: `2px solid ${theme.color(Color.Secondary_600)}`,
    outlineOffset: '1px',
  },
  '&:disabled': {
    cursor: 'not-allowed',
  },
}));
